import { render, staticRenderFns } from "./partsrepair.vue?vue&type=template&id=2166534b&scoped=true"
import script from "./partsrepair.vue?vue&type=script&lang=js"
export * from "./partsrepair.vue?vue&type=script&lang=js"
import style0 from "./partsrepair.vue?vue&type=style&index=0&id=2166534b&prod&lang=css"
import style1 from "./partsrepair.vue?vue&type=style&index=1&id=2166534b&prod&lang=scss&scoped=true"
import style2 from "./partsrepair.vue?vue&type=style&index=2&id=2166534b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2166534b",
  null
  
)

export default component.exports